/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();
/*Common functions*/
 

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

const serializeForm = form => {
    const obj = {};
    const formData = new FormData(form);

    for (const key of formData.keys()) {
        const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

        if (regex.test(key)) {
            obj.properties = obj.properties || {};
            obj.properties[regex.exec(key)[2]] = formData.get(key);
        } else {
            obj[key] = formData.get(key);
        }
    }

    return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': `application/${type}`
        }
    };
}
 


class StateFilterForm extends HTMLElement {
    constructor() {
        super();
        this.filterData = [];
        this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

        this.debouncedOnSubmit = debounce((event) => {
            this.onSubmitHandler(event);

            const dispanceEvent = new CustomEvent('filter_click');
            document.dispatchEvent(dispanceEvent);

        }, 500);

        

        this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
        window.addEventListener('popstate', this.onHistoryChange.bind(this));



        
    }



    onSubmitHandler(event) {
        event.preventDefault();
        const formData = new FormData(event.target.closest('form'));
        const searchParams = new URLSearchParams(formData).toString();

        this.renderPage(searchParams, event);
        
        //console.log('ready', searchParams)

        
    }
    onActiveFilterClick(event) {
        event.preventDefault();
        this.toggleActiveFacets();
        this.renderPage(new URL(event.currentTarget.href).searchParams.toString());

    }

    onHistoryChange(event) {
        const searchParams = event.state ? event.state.searchParams : '';
        this.renderPage(searchParams, null, false);

        var facetA = document.querySelectorAll('custom-facet-remove');

        var checkExist = setInterval(function() {
           if (facetA) {
              
              console.log('exist')
              document.querySelector('state-filter').classList.remove('hidden')

              clearInterval(checkExist);  // Stop checking once the element is found
           }

        }, 100); 

    }

    toggleActiveFacets(disable = true) {
        document.querySelectorAll('.js-facet-remove').forEach((element) => {
            element.classList.toggle('disabled', disable);
        });
    }

    renderPage(searchParams, event, updateURLHash = true) {
        const sections = this.getSections();
        const countContainerDesktop = document.getElementsByClassName('collection-list__products');
        document.querySelector('.section-wrapper').classList.add('loading');
        //document.getElementById('CollectionProductCount').classList.add('loading');
        if (countContainerDesktop) {
            //countContainerDesktop.classList.add('loading');
        }

        sections.forEach((section) => {
            const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
            const filterDataUrl = element => element.url === url;

            this.filterData.some(filterDataUrl) ?
                this.renderSectionFromCache(filterDataUrl, event) :
                this.renderSectionFromFetch(url, event);
        });

        if (updateURLHash) this.updateURLHash(searchParams);

            
         

        


        

    }

    renderSectionFromFetch(url, event) {
        fetch(url)
            .then(response => response.text())
            .then((responseText) => {
                const html = responseText;
                this.filterData = [...this.filterData, {
                    html,
                    url
                }];
                this.renderFilters(html, event);
                this.renderProductGrid(html);
                this.renderProductCount(html);
            });
    }

    renderSectionFromCache(filterDataUrl, event) {
        const html = this.filterData.find(filterDataUrl).html;
        this.renderFilters(html, event);
        this.renderProductGrid(html);
        this.renderProductCount(html);
    }

    renderProductGrid(html) {
        document.getElementById('CollectionProductsContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('CollectionProductsContainer').innerHTML;
    }

    renderProductCount(html) {
        // const count = new DOMParser().parseFromString(html, 'text/html').getElementById('CollectionProductCount').innerHTML
        // const container = document.getElementById('CollectionProductCount');
        // const containerDesktop = document.getElementById('CollectionProductCountDesktop');
        // container.innerHTML = count;
        // container.classList.remove('loading');
        // if (containerDesktop) {
        //     containerDesktop.innerHTML = count;
        //     containerDesktop.classList.remove('loading');
        // }
        document.querySelector('.section-wrapper').classList.remove('loading');
    }
    
    renderFilters(html, event) {
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

        const facetDetailsElements =
            parsedHTML.querySelectorAll('#DesktopFilter .js-filter');
        const matchesIndex = (element) => {
            const jsFilter = event ? event.target.closest('.js-filter') : undefined;
            return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
        }
        const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
        const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);


        facetsToRender.forEach((element) => {
            document.querySelector(`.desktop-fil.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
        });

        
       
       

        this.renderActiveFacets(parsedHTML);


        if (countsToRender) this.renderCounts(countsToRender, event.target.closest('.js-filter'));
       

    }

    renderActiveFacets(html) {
        const activeFacetElementSelectors = ['.active-filters-desktop', '.clear-button-desktop'];

        activeFacetElementSelectors.forEach((selector) => {
          const activeFacetsElement = html.querySelector(selector);
          if (!activeFacetsElement) return;
          document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
        })

        this.toggleActiveFacets(false);

        
    }

   


    renderCounts(source, target) {
    const countElementSelectors = ['.facets__selected_desktop','.facets__selected_mobile'];
    countElementSelectors.forEach((selector) => {
      const targetElement = target.querySelector(selector);
      const sourceElement = source.querySelector(selector);

      if (sourceElement && targetElement) {
        target.querySelector(selector).outerHTML = source.querySelector(selector).outerHTML;
        //

        const count = target.querySelector(selector).innerHTML;
        var matches = count.replace(/\(|\)/g, '');
        var matches = matches.trim();

        //console.log(matches)

        if (matches > 0) {
            target.querySelector(selector).classList.add('display');
        }else{
            target.querySelector(selector).classList.remove('display');
        }


      }
    });
  }


    updateURLHash(searchParams) {
        history.pushState({
            searchParams
        }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    }

    //Add Class
    getSections() {
        return [{
            id: 'CollectionProductsContainer',
            section: document.getElementById('CollectionProductsContainer').dataset.id,
        }]
    }
}
customElements.define('state-filter', StateFilterForm);




// class CustomFacetRemove extends HTMLElement {
//   constructor() {
//     super();
//     this.querySelector('a').addEventListener('click', (event) => {
//       event.preventDefault();
      
      
      
//       const form = document.querySelector('state-filter');

//       form.onActiveFilterClick(event);

      

//     });
//   }
// }

class CustomFacetRemove extends HTMLElement {
  constructor() {
    super();

    const anchor = this.querySelector('a');
    const form = document.querySelector('state-filter');

    if (anchor && form) {
      anchor.addEventListener('click', (event) => {
        event.preventDefault();

        const result = form.onActiveFilterClick(event);

        if (result instanceof Promise) {
          result.then(() => {
            const filterEndEvent = new CustomEvent('filter_end');
            document.dispatchEvent(filterEndEvent);
          });
        } else {
          const filterEndEvent = new CustomEvent('filter_end');
          document.dispatchEvent(filterEndEvent);
        }
      });
    }
  }
}


customElements.define('custom-facet-remove', CustomFacetRemove);


  
 document.addEventListener('filter_end', function(event) {
    
    setTimeout(function(){
        document.querySelector('state-filter').classList.toggle('hidden');
    }, 495)
});
document.addEventListener('filter_click', function(event) {
    console.log('filter_click')
    document.querySelector('state-filter').classList.toggle('hidden');
});

var facetA = document.querySelectorAll('custom-facet-remove');
var checkExist5 = setInterval(function() {
   if (facetA.length > 0) {

      clearInterval(checkExist5); 
      document.querySelector('state-filter').classList.add('hidden')
   }

}, 100); 

 